export const convertToCdnUrl = url =>
  url
    ? url.replace(
        'vtp-video-bucket.s3-ap-southeast-1.amazonaws.com',
        'd1phgg3c9w96v.cloudfront.net'
      )
    : '';
